import req from 'shared/req';

export const updateEducator = (data, fields = '_id') => {
  const id = data.id || 'me';
  delete data.id;

  const url = `/v1/educators/${id}?fields=${fields}`;

  return req({
    url,
    method: 'patch',
    data,
  });
};

export const getEducator = (id = 'me', fields = []) => {
  const url = `/v1/educators/${id}`;

  return req({
    url,
    method: 'get',
    data: {fields},
  });
};
